export function studyPlanEndpoints(blockId) {
  return {
    block: `study_plan_videos/${blockId}`,
    sections: `study_plan_videos/${blockId}/scorm_contents`,
    sectionDone: scormId => [`study_plan_videos/${blockId}/scorm_contents/`, scormId],
    scormQuestions: `study_plan_videos/${blockId}/scorm_questions`
  };
}

export function learningPathEndpoints(blockId) {
  return {
    block: `user_learning_path_blocks/${blockId}`,
    sections: `user_learning_path_blocks/${blockId}/sections`,
    sectionDone: sectionId => [`user_learning_path_blocks/${blockId}/sections/`, sectionId],
    scormQuestions: `user_learning_path_blocks/${blockId}/scorm_questions`
  };
}
